import {
  Box,
  ButtonBase,
  Collapse,
  TableBody,
  Grid,
  IconButton,
  Modal,
  TableContainer,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  useMediaQuery,
  Link,
} from '@mui/material'
import React, { useState } from 'react'
import { fonts, theme } from '../../../theme/DashboardTheme'
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from '@mui/icons-material'
import closeicon from 'shared/assets/icons/successclose.png'
import { ThemeProvider } from '@emotion/react'
import {
  PeopleFinderSelectors,
  putDataBrokerAccuracy,
} from 'shared/redux/peopleFinder/PeopleFinderSlice'
import { useAppDispatch, useAppSelector } from '../../../redux/storeExports'
import Notme from './Notme'
import { MpTypography } from '../atom/MpTypography'
import { normalizeCity } from '../../../utils/helpers'

interface ExposedDataModalProps {
  open: boolean
  rows: Array<Record<string, any>>
  setOpen: (open: boolean) => void
}

const EMPTY_VALUE = '[None]'

const mobileTextSize = {
  fontSize: 'clamp(12px, 4vw, 18px)',
  lineHeight: 'clamp(18px, 5.8vw, 26px)',
}

const mobileTitleSize = {
  fontSize: 'clamp(22px, 7vw, 32px)',
  lineHeight: 'clamp(28px, 8.8vw, 40px)',
}

const formatDisplayValue = (value: any) => {
  if (Array.isArray(value)) {
    const values = value.filter(Boolean).map(String)
    return values.length ? values.join(', ') : EMPTY_VALUE
  }

  if (value === undefined || value === null || value === '') {
    return EMPTY_VALUE
  }

  return String(value)
}

const ExposedDataModal = (props: ExposedDataModalProps) => {
  const handleClose = () => {
    props.setOpen(false)
  }
  const brokerdata = props.rows.map((item, value) => {
    const hasPhones = item.detail?.phones[0]
    const firstname = item.detail?.first_name
    const middlename = item.detail?.middle_name
    const lastname = item.detail?.last_name
    const age = item.detail?.age
    const address = item.detail?.addresses?.[0]
    const email = item.detail?.emails?.[0]
    const cityAndState = [address?.city ? normalizeCity(address.city) : '', address?.state]
      .filter(Boolean)
      .join(', ')
    const Relatives = item.detail?.relatives
    return {
      id: value + 1,
      col1: firstname,
      col2: middlename,
      col3: lastname,
      col4: age,
      col5: cityAndState,
      col6: hasPhones,
      col7: Relatives,
      col8: email,
      col9: item.detail?.link,
      col10: item.detail?.status,
      col11: item.accurate,
      col12: item.scan_result_id,
    }
  })

  const dispatch = useAppDispatch()
  const [expandedRow, setExpandedRow] = useState<number | null>(1)

  const handleRowToggle = (rowId: number) => {
    setExpandedRow((prevRow) => (prevRow === rowId ? null : rowId))
  }
  const broker = useAppSelector(PeopleFinderSelectors.selectBrokerDetails)

  const columns = [
    { key: 'col1', name: 'First Name', resizable: true, width: 136 },
    { key: 'col2', name: 'Middle Name', resizable: true, width: 135.25 },
    { key: 'col3', name: 'Last Name', resizable: true, width: 135.25 },
    { key: 'col4', name: 'Age', resizable: true, width: 77 },
    { key: 'col5', name: 'Address', resizable: true, width: 185 },
    { key: 'col6', name: 'Phones', resizable: true, width: 135.25 },
    { key: 'col7', name: 'Relatives', resizable: true, width: 135.25 },
    { key: 'col8', name: 'Emails', resizable: true, width: 185 },
    { key: 'col9', name: 'Profile Url', resizable: true, width: 120 },
    { key: 'col10', name: 'Action', resizable: true, width: 55 },
    { key: 'col11', name: '', resizable: true },
    { key: 'col12', name: '', resizable: true },
  ]
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <ThemeProvider theme={theme}>
      <Modal open={props.open} onClose={handleClose}>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{
            outline: 'none',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: !isMobile ? '1297px' : 'calc(100% - 20px)',
            maxHeight: '90%',
            overflow: "auto",
            background: '#fff',
            p: isMobile ? { xs: '22px 20px', sm: '20px 16px' } : '30px',
            borderRadius: isMobile ? '8px' : '20px',
          }}>
            <IconButton
              onClick={handleClose}
              sx={{
                position: 'absolute',
                top: isMobile ? 10 : 16,
                right: isMobile ? 10 : 16,
                zIndex: 10,
                background: 'transparent',
                '&:hover': {
                  background: 'transparent',
                },
              }}
            >
              <Box
                component="img"
                src={closeicon}
                sx={{
                  width: isMobile ? 32 : 42,
                  height: isMobile ? 32 : 42,
                }}
              />
            </IconButton>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: -60,
              right: 10,
              zIndex: 1,
              color: '#ffffff',
            }}>
            <img src={closeicon} style={{ width: '42px' }} alt="close" />
          </IconButton>
          <Typography
            variant='h2'
            sx={{
              mb: isMobile ? '24px' : '30px',
              ...(isMobile ? mobileTitleSize : {}),
            }}>
            Exposed Data
          </Typography>
          <Box
            sx={{
              width:!isMobile ? '1237px' : '100%',
              ...(brokerdata.length > 5 &&{
                height: '546px',
                overflowY: 'auto',
              }),
            }}>
            {brokerdata.map((rownew) => (
              <Box key={`box-${rownew.id}`} mb={isMobile ? '24px' : '16px'} width="100%"
                  sx={{
                    overflow: isMobile ? 'visible' : 'auto',
                    border: isMobile && expandedRow === rownew.id ? '1px solid #D8D8DF' : 'none',
                    borderRadius: isMobile ? '8px' : 0,
                    boxShadow: isMobile ? '0px 2px 5px rgba(4, 1, 21, 0.18)' : 'none',
                    backgroundColor: '#FFFFFF',
                  }}
              >
                <Box
                  height={isMobile ? { xs: '50px', sm: '58px' } : '44px'}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  borderBottom={isMobile && expandedRow === rownew.id ? 'none' : '1px solid #ddd'}
                  bgcolor="#C67EFF1A"
                  sx={{ cursor: 'pointer' }}
                                    border="1px solid rgba(198, 126, 255, 0.50)"

                  onClick={() => handleRowToggle(rownew.id)}
                  borderRadius={
                    isMobile
                      ? '8px'
                      : expandedRow === rownew.id
                      ? '20px 20px 0 0'
                      : rownew.id === 1 ?
                        '20px 20px 0 0'
                        : rownew.id === brokerdata.length ?
                          '0 0 20px 20px'
                          : '0'
                  }
                  boxShadow={isMobile && expandedRow === rownew.id ? '0 0 0 4px rgba(126, 85, 199, 0.22)' : 'none'}>
                  <Typography
                    variant="body5"
                    sx={{
                      ml: isMobile ? { xs: '14px', sm: '24px' } : 5,
                      ...(isMobile ? mobileTextSize : {}),
                      color: '#040115',
                    }}>{`Record ${rownew.id}`}</Typography>
                  <IconButton
                    aria-expanded={expandedRow === rownew.id}
                    aria-label="show more"
                    sx={{
                      mr: isMobile ? { xs: '10px', sm: '18px' } : 0,
                      color: expandedRow === rownew.id ? '#5B35A6' : '#6B7280',
                    }}>
                    {expandedRow === rownew.id ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </IconButton>
                </Box>
                <Collapse
                  key={`collapse-${rownew.id}`}
                  in={expandedRow === rownew.id}
                  timeout="auto"
                  unmountOnExit
                  sx={{px: isMobile ? 0 : '20px'}}
                  >
                  {!isMobile ? (
                    <TableContainer sx={{width: '1197px'}}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            {columns.map(
                              (col) =>
                                col.key !== 'col11' &&
                                col.key !== 'col12' && (
                                  <TableCell
                                    style={{
                                      width: col.width,
                                      borderBottom: '1px solid #9135E0',
                                      ...fonts.Inter.SemiBold,
                                      fontSize: '14px',
                                      padding: '16px 0px',
                                    }}
                                    key={`${col.key}-${rownew.id}`}>
                                    {col.name}
                                  </TableCell>
                                ),
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            {columns.map((col) => {
                              if (col.key === 'col11' || col.key === 'col12') {
                                return null;
                              }
                              return (
                              <TableCell
                                key={`${col.key}-${rownew.id}`}
                                sx={{
                                  fontSize: '14px',
                                  ...fonts.Inter.Medium,
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  textAlign: 'flex-start',
                                  px:'0px'
                                }}>
                                {col.key !== 'col10' &&
                                  col.key !== 'col11' &&
                                  col.key !== 'col9' &&
                                  rownew[col.key as keyof typeof rownew] && (
                                    <div>
                                      {Array.isArray(
                                        rownew[col.key as keyof typeof rownew],
                                      )
                                        ? rownew[
                                            col.key as keyof typeof rownew
                                          ].map(
                                            (value: string, index: number) => (
                                              <React.Fragment key={index}>
                                                {value}
                                                <br />
                                              </React.Fragment>
                                            ),
                                          )
                                        : rownew[
                                            col.key as keyof typeof rownew
                                          ]}
                                    </div>
                                  )}

                                {col.key === 'col9' && (() => {
                                  const profileUrl = rownew[col.key as keyof typeof rownew];
                                  return (
                                    <Link 
                                      href={profileUrl}
                                      target="_blank" 
                                      rel="noopener noreferrer"
                                      style={{ 
                                        color: profileUrl ? '#9135E0' : '#A0A0A4',
                                        textDecoration: 'none',
                                        cursor: profileUrl ? 'pointer' : 'default'
                                      }}
                                    >
                                      View Profile
                                    </Link>
                                  );
                                })()}

                                {col.key === 'col10' &&
                                  (rownew[col.key as keyof typeof rownew] ===
                                  'removed' ? (
                                    <MpTypography
                                      variant={'body2'}
                                      sx={{ textAlign: 'start' }}>
                                      Removed
                                    </MpTypography>
                                  ) : (
                                    <>
                                      <Notme
                                        onAccuratePress={() =>
                                          dispatch(
                                            putDataBrokerAccuracy({
                                              scan_result_id: rownew.col12,
                                                accurate: rownew.col11,
                                            }),
                                          )
                                        }
                                        validated={broker?.summary.accurate}
                                      />
                                    </>
                                  ))}
                              </TableCell>
                              );
                            })}
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <Box sx={{ px: { xs: '12px', sm: '24px' }, pt: { xs: '22px', sm: '28px' }, pb: '20px' }}>
                      {[
                        { label: 'First Name', value: rownew.col1 },
                        { label: 'Middle Name', value: rownew.col2 },
                        { label: 'Last Name', value: rownew.col3 },
                        { label: 'Age', value: rownew.col4 },
                        { label: 'Address', value: rownew.col5 },
                        { label: 'Phones', value: rownew.col6 },
                        { label: 'Relatives', value: rownew.col7 },
                        { label: 'Emails', value: rownew.col8 },
                      ].map((field) => {
                        const value = formatDisplayValue(field.value)

                        return (
                          <Box
                            key={`${field.label}-${rownew.id}`}
                            sx={{
                              display: 'grid',
                              gridTemplateColumns: {
                                xs: 'minmax(82px, 38%) 1fr',
                                sm: 'minmax(128px, 42%) 1fr',
                              },
                              columnGap: { xs: '8px', sm: '18px' },
                              mb: { xs: '12px', sm: '18px' },
                            }}>
                            <Typography
                              sx={{
                                ...fonts.Inter.SemiBold,
                                color: '#040115',
                                ...mobileTextSize,
                              }}>
                              {field.label}:
                            </Typography>
                            <Typography
                              sx={{
                                ...fonts.Inter.Medium,
                                color: value === EMPTY_VALUE ? '#6B7280' : '#040115',
                                ...mobileTextSize,
                                overflowWrap: 'anywhere',
                              }}>
                              {value}
                            </Typography>
                          </Box>
                        )
                      })}

                      <Box
                        sx={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 1fr',
                          gap: { xs: '8px', sm: '12px' },
                          mt: { xs: '18px', sm: '22px' },
                        }}>
                        <ButtonBase
                          component={rownew.col9 ? 'a' : 'button'}
                          href={rownew.col9 || undefined}
                          target={rownew.col9 ? '_blank' : undefined}
                          rel={rownew.col9 ? 'noopener noreferrer' : undefined}
                          disabled={!rownew.col9}
                          sx={{
                            width: '100%',
                            height: { xs: '40px', sm: '44px' },
                            border: '1px solid #9135e0',
                            borderRadius: '5px',
                            color: rownew.col9 ? '#9135e0' : '#A0A0A4',
                            backgroundColor: '#FFFFFF',
                            textDecoration: 'none',
                            '&:hover': {
                              backgroundColor: rownew.col9 ? '#F8F0FF' : '#FFFFFF',
                            },
                            '&.Mui-disabled': {
                              borderColor: '#D8D8DF',
                              color: '#A0A0A4',
                            },
                          }}>
                          <Typography
                            sx={{
                              ...fonts.Inter.SemiBold,
                              color: 'inherit',
                              ...mobileTextSize,
                            }}>
                            View Profile
                          </Typography>
                        </ButtonBase>

                        {rownew.col10 === 'removed' ? (
                          <MpTypography
                            variant="subtitle2"
                            sx={{ textAlign: 'center', alignSelf: 'center' }}>
                            Removed
                          </MpTypography>
                        ) : (
                          <ButtonBase
                            onClick={() =>
                              dispatch(
                                putDataBrokerAccuracy({
                                  scan_result_id: rownew.col12,
                                  accurate: rownew.col11,
                                }),
                              )
                            }
                            sx={{
                              width: '100%',
                              height: { xs: '40px', sm: '44px' },
                              borderRadius: '5px',
                              backgroundColor: '#9135e0',
                              boxShadow: '0px 2px 6px rgba(4, 1, 21, 0.3)',
                              color: '#FFFFFF',
                              '&:hover': {
                                backgroundColor: '#9135e0',
                              },
                            }}>
                            <Typography
                              sx={{
                                ...fonts.Inter.SemiBold,
                                color: '#FFFFFF',
                                ...mobileTextSize,
                              }}>
                              {broker?.summary.accurate === false ? 'This Is Me' : 'Not Me'}
                            </Typography>
                          </ButtonBase>
                        )}
                      </Box>
                    </Box>
                  )}
                </Collapse>
              </Box>
            ))}
          </Box>
        </Grid>
      </Modal>
    </ThemeProvider>
  )
}

export default ExposedDataModal
